import React from "react";
import {observer} from "mobx-react-lite";
import {Button, Form, FormField, FormGroup, Grid, Segment} from "semantic-ui-react";
import productInfoStore from "./ProductInfoStore";

function ProductInfo() {
    if (!productInfoStore.visible) {
        return <></>
    }

    return <Grid>
        <Grid.Column width={'7'}>
            <Segment>
                <Form>
                    <FormField>
                        <label>Url</label>
                        <input value={productInfoStore.url}
                               onChange={e => productInfoStore.changeUrl(e.target.value)}/>
                    </FormField>
                    <Button onClick={() => productInfoStore.load()} color={'teal'}>Загрузить</Button>
                    <Button floated={'right'} onClick={() => productInfoStore.hide()}>Закрыть</Button>
                </Form>
            </Segment>
        </Grid.Column>
        {productInfoStore.product &&
            <Grid.Column width={'9'}>
                <Segment>
                    <Form>
                        <FormGroup widths='equal'>
                            <FormField>
                                <label>ProductId</label>
                                <p>{productInfoStore.product.id}</p>
                            </FormField>
                            <FormField>
                                <label>Тип</label>
                                <p>{productInfoStore.product.type}</p>
                            </FormField>
                        </FormGroup>
                        {productInfoStore.product.unloads.map(unload =>
                            <FormGroup widths='equal'>
                                <FormField>
                                    <label>Имя выгрузки</label>
                                    <p>{unload.name}</p>
                                </FormField>
                                <FormField>
                                    <label>UserId</label>
                                    <p>{unload.userId}</p>
                                </FormField>
                            </FormGroup>
                        )}
                    </Form>
                </Segment>
            </Grid.Column>
        }
    </Grid>
}

export default observer(ProductInfo);